import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}

function formatDate(date) {
  return [date.getFullYear(), padTo2Digits(date.getMonth() + 1), padTo2Digits(date.getDate())].join("-");
}

const initialState = {
  data: {
    singlehscodedata: {
      province: "",
      excise: "",
      date: formatDate(new Date()),
      countryofimport: {
        selectedvalue: {
          value: "",
          label: "",
          labelvalue: "",
        },
      },
      incoterms: {
        value: "FOB",
        label: "FOB",
      },
      includefta: "No",
      countryofexport: "United States", // no impact of default value
      countryofmanufacture: "United States", // no impact of default value
      ftatype: {
        value: "",
        label: "",
      },
      transportmode: "Sea",
      hscode: "",
      unit: "Kgs",
      quantity: "",
      currency: "USD",
      costofgood: "",
      freight: "",
      insurance: "",
    },
    submitbutton: false,
    hscodeselected: false,
    calculateddata: [],
    hoverbrowselibrary: false,
  },
};

const singlehscodeSlice = createSlice({
  name: "singlehscodedata",
  initialState,
  reducers: {
    storeSingleHSCodeData(state, action) {
      switch (action.payload.type) {
        case "province":
          state.data.singlehscodedata.province = action.payload.selectedvalue.value;
          break;

        case "excise":
          state.data.singlehscodedata.excise = action.payload.selectedvalue.value;
          break;

        case "import":
          state.data.singlehscodedata.countryofimport = action.payload;
          break;

        case "incoterms":
          state.data.singlehscodedata.incoterms = action.payload.selectedvalue;
          break;

        case "export":
          state.data.singlehscodedata.countryofexport = action.payload;
          break;

        case "manufacture":
          state.data.singlehscodedata.countryofmanufacture = action.payload;
          break;

        case "ftatype":
          state.data.singlehscodedata.ftatype = action.payload.selectedvalue;
          break;

        case "transportmode":
          state.data.singlehscodedata.transportmode = action.payload.selectedvalue;
          break;

        case "singlehscode":
          state.data.singlehscodedata.hscode = action.payload;
          break;

        case "unit":
          state.data.singlehscodedata.unit = action.payload.selectedvalue;
          break;

        case "quantity":
          state.data.singlehscodedata.quantity = action.payload.selectedvalue;
          break;

        case "currency":
          state.data.singlehscodedata.currency = action.payload.selectedvalue;
          break;

        case "costofgood":
          state.data.singlehscodedata.costofgood = action.payload.selectedvalue;
          break;

        case "date":
          state.data.singlehscodedata.date = moment(action.payload.value).format("YYYY-MM-DD");

          break;

        case "freight":
          state.data.singlehscodedata.freight = action.payload.selectedvalue;
          break;

        case "insurance":
          state.data.singlehscodedata.insurance = action.payload.selectedvalue;
          break;

        case "includefta":
          state.data.singlehscodedata.includefta = action.payload.selectedvalue;
          break;

        default:
          break;
      }
    },
    captureSingleHsCodeButtonClick(state, action) {
      state.data.submitbutton = action.payload;
    },

    storeHSCodeSelected(state, action) {
      state.data.hscodeselected = action.payload;
    },

    storeCalculatedData(state, action) {
      state.data.calculateddata = action.payload;
    },

    storeHoverStateBrowseLibrary(state, action) {
      state.data.hoverbrowselibrary = action.payload;
    },
  },
});

export const { storeSingleHSCodeData, captureSingleHsCodeButtonClick, storeHSCodeSelected, storeCalculatedData, storeHoverStateBrowseLibrary } = singlehscodeSlice.actions;

export default singlehscodeSlice.reducer;
